import { isNumber } from "./isNumber";
import { Rounds, round as roundTo } from "./round";

export const formatNumberToLocale = (
  value: number,
  decimalPlaces = 2,
  round: Rounds = Rounds.HalfUp,
  removeTrailingZeros: boolean = false
) => {
  if (!isNumber(value)) {
    console.error("formatNumberToLocale - value parameter is not a number", value);
    value = 0;
  }

  const roundedValue = roundTo(value, decimalPlaces, round);
  return roundedValue.toLocaleString("en", {
    ...(removeTrailingZeros ? {} : { minimumFractionDigits: decimalPlaces }),
    maximumFractionDigits: decimalPlaces,
  });
};
